<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>Genel Bilgi</b-card-title>
          <b-avatar
            v-if="employee.name && employee.surname"
            size="150px"
            variant="secondary"
            :text="employee.name.charAt(0)+employee.surname.charAt(0)"
          />
          <div
            class="mt-2"
          >
            <div class="font-medium-4 font-weight-bolder">
              {{ employee.name }} {{ employee.surname }}
            </div>
            <b-row>
              <b-col>
                <div
                  v-if="employee.phone_personal"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    Telefon (Kişisel)
                  </div>
                  <div>{{ employee.phone_personal }}</div>
                </div>
              </b-col>
              <b-col>
                <div
                  v-if="employee.phone_business"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    Telefon (İş)
                  </div>
                  <div>{{ employee.phone_business }}</div>
                </div>
              </b-col>
              <b-col>
                <div
                  v-if="employee.email_personal"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    E-Posta (Kişisel)
                  </div>
                  <div>{{ employee.email_personal }}</div>
                </div>
              </b-col>
              <b-col>
                <div
                  v-if="employee.email_business"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    E-Posta (İş)
                  </div>
                  <div>{{ employee.email_business }}</div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  v-if="employee.started"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    İşe Başlama Tarihi
                  </div>
                  <div>{{ this.moment(employee.started).format('DD.MM.YYYY') }}</div>
                </div>
              </b-col>
              <b-col>
                <div
                  v-if="employee.contracted"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    Sözleşme Türü
                  </div>
                  <div>Süreli</div>
                </div>
              </b-col>
              <b-col>
                <div
                  v-if="employee.contracted"
                  class="mt-2"
                >
                  <div class="font-weight-bold">
                    Sözleşme Bitiş Tarihi
                  </div>
                  <div>{{ this.moment(employee.contracted).format('DD.MM.YYYY') }}</div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card>
        <b-card>
          <b-card-title>Kariyer</b-card-title>
          <b-row>
            <b-col>
              <div
                v-if="employee.department"
                class="mt-2"
              >
                <div class="font-weight-bold">
                  Departman
                </div>
                <div>{{ positions.title }}</div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <pre>
    {{ employee }}
    {{ banks }}
    {{ contacts }}
    {{ personals }}
    {{ positions }}
    </pre>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BCardTitle, BAvatar,
} from 'bootstrap-vue'

export default {
  name: 'View',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BAvatar,
  },
  computed: {
    employee() {
      return this.$store.getters['employees/getEmployee']
    },
    banks() {
      return this.$store.getters['employeeBank/getEmployeeBanks']
    },
    contacts() {
      return this.$store.getters['employeeContact/getEmployeeContacts']
    },
    personals() {
      return this.$store.getters['employeePersonal/getEmployeePersonals']
    },
    positions() {
      return this.$store.getters['employeePosition/getEmployeePositions']
    },
  },
  created() {
    this.getEmployee()
    this.getEmployeeBank()
    this.getEmployeeContact()
    this.getEmployeePersonal()
    this.getEmployeePosition()
  },
  methods: {
    getEmployee() {
      this.$store.dispatch('employees/employeeView', this.$route.params.id)
    },
    getEmployeeBank() {
      this.$store.dispatch('employeeBank/employeeBanksList', {
        where: {
          'employee_bank.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    getEmployeeContact() {
      this.$store.dispatch('employeeContact/employeeContactsList', {
        where: {
          'employee_contact.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    getEmployeePersonal() {
      this.$store.dispatch('employeePersonal/employeePersonalsList', {
        where: {
          'employee_personal.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
    getEmployeePosition() {
      this.$store.dispatch('employeePosition/employeePositionsList', {
        where: {
          'employee_position.id_employees': this.$route.params.id,
        },
        array: false,
      })
    },
  },
}
</script>

<style scoped>

</style>
